import { render, staticRenderFns } from "./vendor-list.vue?vue&type=template&id=b565f6ba&"
import script from "./vendor-list.vue?vue&type=script&lang=js&"
export * from "./vendor-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports